import React from 'react';
import InsightHeader from '@shared/components/texts/InsightHeader';
import { OBMAdvancedSettingsSwitch } from '@domain/segments/segments-table/segments-table-header/obm-advanced-settings-switch';
import { OBM_TABLE_HEADER_TEXTS } from '@domain/segments/segments-table/segments-table-header/obm-table-header.constants';
import {
    HeaderWrapper,
    HeaderLeft,
    HeaderRight,
    MenuWrapper,
    StyledInputWithSearch,
    OBMAdvancedSettingsWrapper,
    OBMAdvancedSettingsLabel,
} from './table-header-component.styles';
import { TableHeaderComponentProps } from './table-header-component.types';
import { COLUMN_TABLE_APPCUES_ID } from '../column-table-menu/column-table-menu.constants';
import { ColumnsTableMenu } from '../column-table-menu/column-table-menu';

const defaultProps = {
    searchText: '',
};

export const TableHeaderComponent = ({
    onChange,
    searchText,
    selectedMetrics,
    setSelectedMetrics,
    metrics,
    advancedMetrics,
    dataAppcuesId,
    texts,
    isOBMTable,
}: TableHeaderComponentProps) => (
    <HeaderWrapper>
        <HeaderLeft>
            <InsightHeader
                title={texts.TITLE}
                subtitle={texts.SUBTITLE}
                dataAppcuesId={dataAppcuesId}
            />
        </HeaderLeft>
        <HeaderRight>
            <MenuWrapper>
                {
                    isOBMTable
                        ? (
                            <OBMAdvancedSettingsWrapper>
                                <OBMAdvancedSettingsLabel>
                                    {OBM_TABLE_HEADER_TEXTS.ADVANCED_SWITCH}
                                </OBMAdvancedSettingsLabel>
                                <OBMAdvancedSettingsSwitch
                                    selectedMetrics={selectedMetrics}
                                    setSelectedColumns={setSelectedMetrics}
                                />
                            </OBMAdvancedSettingsWrapper>
                        ) : null
                }
                <StyledInputWithSearch
                    onChange={onChange}
                    placeholder={texts.PLACEHOLDER}
                    value={searchText}
                />
                <ColumnsTableMenu
                    dataAppcuesId={COLUMN_TABLE_APPCUES_ID.METRICS_SELECTOR}
                    selectedColumns={selectedMetrics}
                    setSelectedColumns={setSelectedMetrics}
                    metrics={metrics}
                    advancedMetrics={advancedMetrics}
                />
            </MenuWrapper>
        </HeaderRight>
    </HeaderWrapper>
);

TableHeaderComponent.defaultProps = defaultProps;
